async function baseUrlDorape() {
    let url = "sdfasfs";
    await fetch("config/config.json")
        .then(resp => {
            return resp.json();
        })
        .then(config => {
            // console.log(config.api);
            url = config.api;
        })
        .catch(err => {
            url = "https://prontuarioapi.agape-sistemas.com/api";
        });

    return url;
}

// const baseUrlDorape = "https://localhost:7202/api";
// const baseUrlDorape = "https://prontuarioapi.agape-sistemas.com/api";
// const baseUrlDorape = "https://Ortopediaapi.agape-sistemas.com/api/";

enum TipoMensagem {
    Alert,
    Error,
    Information
}

export { baseUrlDorape, TipoMensagem };